export const BEARER = "Bearer ";
export const BASE_URL = process.env.REACT_APP_BASE_ROUTE;
export const ROUTE_POST_USERDATA = "/api/v1/auth/getUserData";
export const ROUTE_POST_LOGIN    = "/api/v1/auth/login";
export const ROUTE_POST_LOGOUT   = "/api/v1/auth/logout";
export const ROUTE_GET_SURVEY    = "/api/v1/surveys";

export const ROUTE_GET_SURVEY2    = "/api/v1/responses/getLastResponse";
export const ROUTE_POST_SURVEY   = "/api/v1/responses/save";
export const ROUTE_GET_SURVEYS   = "/api/v1/surveys/list";